import { redirect, type RouteObject } from 'react-router'

import { adminRoutes } from '@bettermode/domain/routes/web/admin'

import type { InjectedAppProps } from '../server/types/server.types.js'

import { appStoreRoutes } from './appStoreRoutes.js'
import { billingRoutes } from './billingRoutes.js'
import { contentRoutes } from './contentRoutes.js'
import { miscRoutes, templatesRoute } from './miscRoutes.js'
import { peopleRoutes } from './peopleRoutes.js'
import { createReportsRoutes } from './reportsRoutes.js'
import { settingsRoutes } from './settingsRoutes.js'
import { siteRoutes } from './siteRoutes.js'

export const createManageRoutes = (
  injectedAppProps: InjectedAppProps,
): RouteObject => ({
  path: adminRoutes.root,
  async lazy() {
    const { AdminMode } = await import(
      '../client/components/Admin/Modes/AdminMode.js'
    )
    const { RouterErrorBoundary } = await import(
      '../client/components/Error/RouterErrorBoundary.js'
    )

    return {
      Component: AdminMode,
      errorElement: <RouterErrorBoundary />,
    }
  },
  children: [
    {
      index: true,
      loader: () => redirect('people'),
    },
    peopleRoutes,
    contentRoutes,
    siteRoutes,
    settingsRoutes,
    billingRoutes,
    templatesRoute,
    createReportsRoutes(injectedAppProps),
    appStoreRoutes,
    miscRoutes,
  ],
})
